export const CsticNames = {
  KITLeft: "kit left",
  KITCenter: "kit center",
  KITRight: "kit right",
  StandardKits: "Standard kits",
  CarriageDesign: "Carriage Design",
  LubricationConnectorOrientation: "LC Orientation",
  LubricationConnectorPosition: "LC Position",
  LubricationConnector: "Lubrication Connector",
  LubricationConnectorAlignment: "LC Alignment",
  LubricationConnectorType: "LC Type",
  EnableCarriageEditButton: "Enable Edit",
} as const;

export const ExtraConfig = {
  carriageDesignEditable: "carriageDesignEditable",
  singleCarriageMode: "singleCarriageMode",
};
